import React from 'react';
import imagePath from '../img/envision/homeservices/DIGITAL TWIN_1.jpg';
import imagePath1 from '../img/envision/homeservices/updated/bnkj.jpg';
import imagePath2 from '../img/envision/homeservices/cleanenergy.jpg';
import imagePath3 from '../img/envision/homeservices/chemicals.jpg';
import imagePath4 from '../img/envision/homeservices/updated/HEALTHCARE & LIFE SCIENCES - 03.jpg';
import imagePath5 from '../img/envision/homeservices/recognization2.JPG';
import imagePath6 from '../img/envision/homeservices/updated/comu.jpg';
import imagePath7 from '../img/envision/homeservices/updated/AEROSPACE - 03.jpg';
import imagePath8 from '../img/envision/dropdown/new/aut.png';
import bg6 from '../img/envision/homeservices/manufacturedd.jpg'; // Adjust the path according to your project structure
import { Link } from "react-router-dom";

const ImageGallery = () => {
  return (
    <div id="hs_cos_wrapper_widget_57513681039" style={{ width: '100%', }} className='home-sustance-data'>
      <style>
        {`
          .img-gallery-section {
            padding: 20px;
          }

          

          .gallery-col {
            padding: 10px;
          }

          .img-container {
            position: relative;
            overflow: hidden;
            border: 1px solid #ddd;
            border-radius: 5px;
            margin-bottom: 20px;
          }

          .img-container img {
            width: 100%;
            height: 450px;
            display: block;
            transition: transform 0.3s ease-in-out;
          }

          .img-container:hover img {
            transform: scale(1.1);
          }

          .details {
            position: absolute;
            bottom: -100%;
            left: 0;
            width: 100%;
            padding: 15px;
            background: rgb(236 115 34);
            text-align: center;
            transition: bottom 0.3s ease-in-out;
          }

          .img-container:hover .details {
            bottom: 0;
          }

          .img-title {
            font-size: 18px;
            font-weight: bold;
            color: #000;
          }

          .img-description {
            font-size: 14px;
            color: #000;
          }
        `}
      </style>

      <section className="img-gallery-section">
        <div className="container-fluid" style={{ maxWidth: '100%' }}>
          <div className="row" style={{}}>
            <div className="col-12">
              <h1 style={{ color: 'rgb(236 115 34)', width: '500px', fontSize: '40px', }} className='home-title-name'>
                Designing Resilient and continuous <span style={{ color: '#000' }}> business systems </span>

              </h1>
            </div>
          </div>

          <div className="row">
            <div className="col-12 col-md-6 col-lg-3 gallery-col aero-data-card" >
              <div className="img-container">
                <Link to="/aerospace">
                  {/* <a href="aerospace"> */}
                  <img src={imagePath7} alt="IT Risk & Governance" />
                  <div className="details">
                    <p className="img-title">AEROSPACE & DEFENSE</p>
                    <p className="img-description">"Propelling the aerospace industry toward innovation with secure, resilient, and cutting-edge solutions."</p>
                  </div>
                </Link>
                {/* </a> */}
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-3 gallery-col aero-data-card-two" >
              <div className="img-container">
                <Link to="/automotivemobility">
                  {/* <a href="automotivemobility"> */}
                  <img src={imagePath8} alt="IT Risk & Governance" />
                  <div className="details">
                    <p className="img-title">AUTOMOTIVE, RAIL, AND NEXT-GEN MOBILITY </p>
                    <p className="img-description">"Driving the future of Automotive, Rail, and Next-Gen Mobility with intelligent, secure, and transformative solutions."</p>
                  </div>
                </Link>
                {/* </a> */}
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-3 gallery-col">
              <div className="img-container">
                <Link to="/energy">
                  <img src={imagePath1} alt="Digital Twin" />
                  <div className="details">
                    <p className="img-title">BFSI</p>
                    <p className="img-description">"Empowering BFSI with Secure, Smart, and Compliant Technology."</p>
                  </div>
                </Link>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-3 gallery-col aero-data-card-fourth" >

              {/* <div className="img-container">
                <Link to="/communication">
                  
                  <img src={imagePath6} alt="Digital Healthcare" />
                  <div className="details">
                    <p className="img-title">MEDIA & COMMUNICATIONS</p>
                    <p className="img-description">Transforming the Communication Industry with next-generation security,
                      seamless connectivity, and resilient digital infrastructure.</p>
                  </div>
                  
                </Link>
              </div> */}


              
              <div className="img-container">
                <Link to="/energyPagedata">

                  <img src={imagePath2} alt="Intelligent Mobility" />
                  <div className="details">
                    <p className="img-title">ENERGY & INFRASTRCUTURE</p>
                    <p className="img-description">
                      "Energizing the Future with Intelligent, Secure, and Renewable-Driven Solutions."
                    </p>
                  </div>

                </Link>
              </div>

            </div>






          </div>
        </div>


        <div className="container-fluid " style={{ maxWidth: "100%", }}>
          <div className="row">
            <div className="col-12 col-md-6 col-lg-3 gallery-col aero-data-card-fivth" >
              {/* <div className="img-container">
                <Link to="/energyPagedata">
                 
                  <img src={imagePath2} alt="Intelligent Mobility" />
                  <div className="details">
                    <p className="img-title">ENERGY & INFRASTRCUTURE</p>
                    <p className="img-description">
                      "Energizing the Future with Intelligent, Secure, and Renewable-Driven Solutions."
                    </p>
                  </div>
                 
                </Link>
              </div> */}
              <div className="img-container">
                <Link to="/healthcare">

                  <img src={imagePath4} alt="Digital Healthcare" />
                  <div className="details">
                    <p className="img-title">HEALTHCARE & LIFE SCIENCES</p>
                    <p className="img-description">"Enabling Secure, Smart and Globally Compliant Pharma Solutions."</p>
                  </div>

                </Link>
              </div>
            </div>

            <div
              className="col-12 col-md-6 col-lg-3 gallery-col aero-data-card-sixth"

            >
              {/* <div className="img-container">
                <Link to="/healthcare">
                  
                  <img src={imagePath4} alt="Digital Healthcare" />
                  <div className="details">
                    <p className="img-title"> HEALTHCARE</p>
                    <p className="img-description">"Enabling Secure, Smart and Globally Compliant Pharma Solutions."</p>
                  </div>
                
                </Link>
              </div> */}
              <div className="img-container">
                <Link to="/manufacturingpage">

                  <img src={bg6} alt="Intelligent Mobility" />
                  <div className="details">
                    <p className="img-title"> MANUFACTURING</p>
                    <p className="img-description">
                      "Driving Manufacturing Excellence through Resilient, Innovative, and Sustainable Solutions."
                    </p>
                  </div>

                </Link>
              </div>
            </div>

            <div
              className="col-12 col-md-6 col-lg-3 gallery-col aero-data-card-seven"

            >
              {/* <div className="img-container">
                <Link to="/manufacturingpage">
                 
                  <img src={bg6} alt="Intelligent Mobility" />
                  <div className="details">
                    <p className="img-title"> MANUFACTURING</p>
                    <p className="img-description">
                      "Driving Manufacturing Excellence through Resilient, Innovative, and Sustainable Solutions."
                    </p>
                  </div>
                
                </Link>
              </div> */}
              <div className="img-container">
                <Link to="/communication">

                  <img src={imagePath6} alt="Digital Healthcare" />
                  <div className="details">
                    <p className="img-title">MEDIA & COMMUNICATIONS</p>
                    <p className="img-description">Transforming the Communication Industry with next-generation security,
                      seamless connectivity, and resilient digital infrastructure.</p>
                  </div>

                </Link>
              </div>
            </div>
          </div>
        </div>

      </section>
    </div>
  );
};

export default ImageGallery;
